module.exports = __webpack_public_path__ + "img/Tyreece John-Jules.bb8545ea.png";